import { sportService } from '@/services/sport.service';
import { getDummySetting } from '@/utils/saba-sports-util';
import { useParams, useSelectedLayoutSegments, useSearchParams } from 'next/navigation';

export const useSportMenuActived = () => {
	const params = useParams();
	const searchParams = useSearchParams();
	const selectedLayoutSegments = useSelectedLayoutSegments();
	const isLivePage = selectedLayoutSegments.includes('live');
	const isWorldPage = selectedLayoutSegments.includes('world');

	/**
     * Example: current route: sport=1
	 * - isLive: /live/1 => pass
	 * - !isLive: /sport/1/t => pass
     * - !isLive: /sport/2/t => fail
	 * @returns check result
	 */
	const isSportActived = (href: string) => {
		if (isWorldPage) {
			return false;
		}
		const routePrefix = isLivePage ? 'live' : 'sports';
		if (sportService.isKironVirtualSport(href.match(/\/(\d+)(?:\/|$)/)?.[1] || '') && sportService.isKironVirtualSport(params.sport as string)) {
			return true;
		}
		return new RegExp(`^\\/${routePrefix}\\/${params.sport}(?:\/|$)`).test(href);
	};

	const isVirtualSportActived = () => sportService.isAnyVirtualSportsProduct(Number(params.sport))

	const isDummySportCategoryActived = (sport: number) => getDummySetting(Number(params.sport))?.categoryId === sport;

	const isActivedByLeagueGroupId = (href: string) => {
		const hrefWithoutQueryString = href.indexOf('?') === -1 ? href : href.substring(0, href.indexOf('?'));
		const sportActivated = isSportActived(hrefWithoutQueryString);
		if (!sportActivated) {
			return false;
		}
		const leagueGroupIdInUrl = searchParams.get('lgid');
		const isLeagueGroupIdProvided = href.indexOf('lgid=') !== -1;
		if (!isLeagueGroupIdProvided && !leagueGroupIdInUrl) {
			return true;
		}
		const providedLeagueGroupId = href.replace(/.+lgid=(\d+)/, '$1');
		return leagueGroupIdInUrl === providedLeagueGroupId;
	};
	const isCricketGameTypeActived = (href: string, idx: number) => {
		const hrefWithoutQueryString = href.indexOf('?') === -1 ? href : href.substring(0, href.indexOf('?'));
		const sportActivated = isSportActived(hrefWithoutQueryString);
		if (!sportActivated) {
			return false;
		}
		const gameTypeParam = searchParams.get('gametype');

		if (!gameTypeParam && idx == 0) {
			return true;
		}

		const providedGameType = href.match(/gametype=([^&]*)/);
		return gameTypeParam === (providedGameType ? providedGameType[1] : '');
	};

	return {
		isSportActived,
		isActivedByLeagueGroupId,
		isCricketGameTypeActived,
		isVirtualSportActived,
		isDummySportCategoryActived
	};
};